module.exports = __webpack_public_path__ + "img/tooltip_13-vallone-litho-calce-grigio-tremezzo.8d3265b8.jpg";